import nextCookie from 'next-cookies';

/**
 * Same rules as `pages/_app.js` `isAuth` — token + user_type/user_id from cookies.
 * Use in getInitialProps for pages that render outside Layout (e.g. /become-a-tutor header).
 */
export function authFromCookies(ctx) {
  const { token, user_type, user_id } = nextCookie(ctx);

  if (ctx.req && !token) {
    return false;
  }

  if (!token) {
    return false;
  }

  return {
    user_type,
    user_id,
  };
}
